import React from 'react';
import { ArrowRightIcon, MapPinIcon, ShieldCheckIcon } from 'lucide-react';
import { images } from '../data/business';
export function Hero() {
  return <section id="top" className="relative isolate overflow-hidden bg-navy" data-id="element-92" data-mp="ehtk3yp8h5ov">
      <img src={images.hero} alt="Freshly renovated backyard pool with new tile and travertine deck inside a screened lanai in Central Florida" className="absolute inset-0 -z-10 h-full w-full object-cover object-[60%_center]" data-id="element-93" data-mp="9lbfqzxtf9d2" />
      <div className="absolute inset-0 -z-10 bg-navy/70 md:bg-transparent md:bg-gradient-to-r md:from-navy/95 md:via-navy/70 md:to-navy/10" aria-hidden="true" data-id="element-94" data-mp="x9urjpg2q49w" />

      <div className="mx-auto flex min-h-[600px] max-w-7xl flex-col justify-center px-5 pb-16 pt-16 md:min-h-[680px] lg:min-h-[760px] lg:px-8" data-id="element-95" data-mp="nc85mj0cxcgf">
        <p className="flex items-center gap-2 text-sm font-semibold text-accent md:text-base" data-id="element-96" data-mp="3d2bidl8y6rtf">
          <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="381nv9anuav4h" />
          Orlando &amp; Central Florida
        </p>
        <h1 className="mt-5 max-w-4xl font-display text-[2.9rem] font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-[5.5rem]" data-id="element-98" data-mp="3j924lm8avmuh">
          Bring Your Pool <span className="text-accent" data-id="element-99" data-mp="39b4gqzucrs2e">Back to Life.</span>
        </h1>
        <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/90 md:text-xl" data-id="element-100" data-mp="3e9607lvoxtee">
          Professional pool renovation for homeowners in Orlando and Central Florida.
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-101" data-mp="30g6kpjvwrz6u">
          <a href="#estimate" className="btn-primary text-lg" data-id="element-102" data-mp="35aausc0h0nc5">
            Get Your Free Estimate
            <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-103" data-mp="2qlenwia5hgd4" />
          </a>
          <a href="#work" className="btn-light text-lg" data-id="element-104" data-mp="2vjzo4hpek01k">
            View Our Work
          </a>
        </div>

        <p className="mt-8 flex items-start gap-2 text-sm text-white/85 md:text-[15px]" data-id="element-105" data-mp="2hkgh5s8buuqu">
          <ShieldCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-106" data-mp="2ljpef72ktar5" />
          Trusted pool renovation service for Central Florida homeowners.
        </p>
      </div>
    </section>;
}